const routeCategory = {
  solution: 1,
  industryPavilionCase: 2,
  creativeInteraction: 13,
  news: 14,
  about: 47,
  contact: 51,
};

export const setNowRoute = (routeName) => {
  const pid = routeCategory[routeName];
  if (pid) {
    sessionStorage.setItem("333f-now-tab", pid);
  }
};

export const getPageId = (routeName) => {
  const categoryId = routeCategory[routeName];

  return categoryId;
};



// WEBPACK FOOTER //
// ./src/js/nowRoute.js